$(document).ready(() => { 
  function find(item) {
    const video = $(item).closest('.common-videojs-block')
    return video.find('video').get(0);
  }

  $('.display').on('click', function() {
    const cards = $(this).closest('.care-guide-content').find('.card')
    $(cards).addClass('active')
    $(this).removeClass('active')
    $(this).next().addClass('active')
  })

  $('.conceal').on('click', function() {
    const cards = $(this).closest('.care-guide-content')
    $('.common-videojs-block .Pause').click()
    cards.find('.desktop-only:nth-child(n+8)').removeClass('active')
    cards.find('.mobile-only:nth-child(n+9)').removeClass('active')
    $(this).removeClass('active')
    $(this).prev().addClass('active')
  })

  const defaultProps = {
    observer: true,
    slidesPerView: 1.05,
    spaceBetween: 12,
    navigation: {
      nextEl: '.swiper-next',
      prevEl: '.swiper-prev',
    },
  }

  new Swiper ('[care-guide_ambassador-swiper]', defaultProps);

  new Swiper ('[care-guide-swiper]', { ...defaultProps, slidesPerView: 1, spaceBetween: 18 });

  $(".card_content").click(function() {
    const data = $(this).data()
    openSubpage(data)
  })

  $(document).on('click', '.care-guide_content-header .card', function() {
    const target = $(this).attr('href')
    $('html').stop().animate({
      'scrollTop': $(target).offset().top
    }, 100, 'linear');
  })
})